<div *ngIf="showPanel">
    <div *ngIf="showChooser" class="scanner-mode-tabs">
        <div class="tab-switcher" [class.laser-active]="scannerMode === ScannerMode.Laser">
            <button class="tab-button" 
                    [class.active]="scannerMode === ScannerMode.Camera"
                    (click)="setScannerMode(ScannerMode.Camera)"
                    i18n="Device Camera|@@scanner_mode_camera">
                Device Camera
            </button>
            <button class="tab-button" 
                    [class.active]="scannerMode === ScannerMode.Laser"
                    (click)="setScannerMode(ScannerMode.Laser)"
                    i18n="Laser Scanner|@@scanner_mode_laser">
                Laser Scanner
            </button>
        </div>
    </div>

    <div *ngIf="showBarcodeImage" class="item scan" [class.pointer]="scannerMode === ScannerMode.Camera" (click)="openScanPopup()">
        <img [src]="scannerMode === ScannerMode.Camera ? scanIconPath : laserIconPath" />
        <div class="label">
            <span *ngIf="scannerMode === ScannerMode.Camera" i18n="Camera scan instruction|@@camera_scan_instruction">Tap to scan - with camera</span>
            <span *ngIf="scannerMode === ScannerMode.Laser" i18n="Laser scan instruction|@@laser_scan_instruction">Scan barcode - with laser scanner</span>
        </div>
    </div>

    <span *ngIf="showBarcodeInstruction && scannerMode === ScannerMode.Laser" i18n="Laser scan instruction|@@laser_scan_instruction" class="laser-instruction">Point the device to the barcode.</span>

    <div class="item textbox-container" *ngIf="showManualBarcodeInput">
        <i class="dx-icon-search search-icon"></i>
        <dx-autocomplete #barcodeAutoComplete
            class="barcode-auto-complete"
            placeholder="Enter barcode manually" 
            valueExpr="barcode" 
            [dataSource]="barcodeDataSource"
            [(value)]="barcodeInput" 
            searchExpr="barcode" 
            (onSelectionChanged)="onBarcodeSelected($event)"
            (onEnterKey)="onBarcodeInputEnterKeyPress($event)"
            [maxItemCount]="100">
        </dx-autocomplete>
        <div *ngIf="showBarcodeButton"
            class="barcode-button"
            (click)="barcodeButton.onClick(barcodeAutoComplete.value)">
            {{barcodeButton.text}}
        </div>
    </div>

    <div class="item textbox-container" *ngIf="showLookupSection">
        <i class="dx-icon-search search-icon"></i>
        <dx-lookup
            class="lookup"
            [dataSource]="lookupDataSource" 
            [displayExpr]="lookupDisplayExpr" 
            [valueExpr]="lookupValueExpr" 
            [searchExpr]="lookupSearchExpr"
            [placeholder]="lookupPlaceholder" 
            searchPlaceholder="Search" 
            [showClearButton]="false" 
            [(value)]="lookupValue"
            (onSelectionChanged)="onLookupSelected($event)">
            <dxo-drop-down-options [fullScreen]="globalsService?.isMobile" [hideOnOutsideClick]="true">
            </dxo-drop-down-options>
        </dx-lookup>
    </div>
</div>

<!-- <div *ngIf="showChooser && chooserMode === 'icons'" class="change-scanner-device" i18n="Change Scanner Device|@@change_scanner_device">
    <img src="../../assets/img/icons/stock-mobile/phone-camera.svg" 
            alt="Phone Camera" 
            [class.selected]="scannerMode === ScannerMode.Camera"
            (click)="setScannerMode(ScannerMode.Camera)" />
    <img src="../../assets/img/icons/stock-mobile/scan.svg" 
            alt="Scan" 
            [class.selected]="scannerMode === ScannerMode.Laser"
            (click)="setScannerMode(ScannerMode.Laser)" />
</div> -->

<app-barcode-scanner #barcodeScanner
    [scanOnlyBarcode]="scanOnlyBarcode"
    [showBarcode]="showBarcodeScanner" 
    (scanSuccess)="scanSuccessHandler($event)" 
    (scannerClose)="scannerCloseHandler()">
</app-barcode-scanner>

<app-barcode-laser #laserScanner
    *ngIf="scannerMode === ScannerMode.Laser"
    [isActive]="scannerMode === ScannerMode.Laser"
    (scanSuccess)="scanSuccessHandler($event)"
    (enterKeyPressed)="enterKeyPressedHandler()"
    (escapeKeyPressed)="escapeKeyPressedHandler()">
</app-barcode-laser>

<!-- Floating Camera Button -->
<div class="floating-camera-button" [class.with-bottom-nav]="withBottomNav" (click)="openScanPopup()" *ngIf="scannerMode === ScannerMode.Camera && showFloatingCameraButton">
    <img src="assets/img/icons/stock-mobile/photo-white.svg" alt="Camera" />
</div>
